import styled, { css } from 'styled-components';
import { hexToRGB } from '@repo-level/core-front';

export const ScArrowOutsideBox = styled.div`
  position: relative;
  width: 80px;
  height: 32px;
  display: flex;
  border-radius: 8px;
  background: ${({ theme }) => theme.grayColor5};

  &:after {
    position: absolute;
    content: '';
    top: 6px;
    bottom: 6px;
    left: 50%;
    width: 1px;
    background: ${({ theme }) => hexToRGB(theme.whiteColor, 0.1)};
  }
`;

export const ScArrowOutside = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 0 0 50%;
  max-width: 50%;
  height: 32px;
  border: none;
  z-index: 2;
  transition: 0.3s;
  background: transparent;
  svg {
    vertical-align: middle;
    z-index: 1;
    transition: 0.3s;
    path {
      transition: 0.3s;
      fill: ${({ theme, disabled }) =>
        `${hexToRGB(theme.whiteColor, disabled ? 0.1 : 0.4)}`};
    }
  }
  button {
    width: 100%;
  }
  ${({ disabled }) =>
    !disabled &&
    css`
      cursor: pointer;
      &:hover {
        path {
          fill: ${({ theme }) => theme.whiteColor};
        }
      }
    `}
`;

export interface Position {
  top?: string;
  bottom?: string;
  left?: string;
  right?: string;
}

export interface ScArrowInsideProps {
  hide?: boolean;
  arrowShift?: number;
  arrowWidth?: number;
  leftArrowPosition?: Position;
  rightArrowPosition?: Position;
  isNewUser?: boolean;
  bgArrowButtons?: string;
}

export const ScArrowInside = styled.button<ScArrowInsideProps>`
  position: absolute;
  top: 50%;
  transform: ${({ isNewUser }) =>
    `translateY(${isNewUser ? '50% - 88px' : '50%'})`};
  width: 32px;
  height: 32px;
  border: none;
  cursor: pointer;
  z-index: 2;
  background: ${({ bgArrowButtons, theme }) =>
    bgArrowButtons ? bgArrowButtons : hexToRGB(theme.whiteColor, 0.2)};
  border-radius: 8px;
  padding: 8px 12px;

  svg {
    path {
      transition: 0.3s;
    }
  }

  @media (hover: hover) {
    &:hover {
      path {
        fill: ${({ theme }) => theme.whiteColor};
      }
    }
  }
`;

export const ScArrowInsidePrev = styled(ScArrowInside)<{ position?: Position }>`
  left: 16px;

  ${({ position }) => {
    if (!position) return;

    const { top, right, left, bottom } = position;

    return css`
      top: ${top ? top : '50%'};
      left: ${left ? left : 'auto'};
      bottom: ${bottom ? bottom : 'auto'};
      right: ${right ? right : 'auto'};
    `;
  }}
`;

export const ScArrowInsideNext = styled(ScArrowInside)<{ position?: Position }>`
  right: 16px;

  ${({ position }) => {
    if (!position) return;

    const { top, right, left, bottom } = position;

    return css`
      top: ${top ? top : '50%'};
      left: ${left ? left : 'auto'};
      bottom: ${bottom ? bottom : 'auto'};
      right: ${right ? right : 'auto'};
    `;
  }}
`;
